
  import EventBus from '@/events/EventBus';
  import Events from '@/events/Events';

  export default {
    name: 'FavorJobPostingButton',
    props: {
      job: {
        type: Object,
        required: true,
      },
      hasFavorite: {
        type: Boolean,
        required: true,
      },
      topJob: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      alreadyFavored: false,
      disabled: false,
    }),
    methods: {
      favorJob() {
        this.disabled = true;
        this.$store
          .dispatch('api/favorite/postFavorJobPosting', {
            id: this.job.id,
            data: {
              notes: '',
            },
          })
          .then(() => {
            EventBus.$emit('favored-job', this.job.id);
            this.$emitWithClientData(Events.JobFavored, {
              jobPostingId: this.job.id,
            });
          })
          .catch((e) => {
            if (e.response.status === 400) {
              this.alreadyFavored = false;

              if (e.response.data['hydra:code'] === 200) {
                this.alreadyFavored = true;
                return;
              }
            }

            throw e;
          });
        setTimeout(() => (this.disabled = false), 3000);
      },
      unfavorJob() {
        this.disabled = true;

        this.$store
          .dispatch('api/favorite/postUnfavorJobPosting', this.job.id)
          .then(() => {
            EventBus.$emit('unfavored-job', this.job.id);
            this.$emitWithClientData(Events.JobUnfavored, {
              jobPostingId: this.job.id,
            });
          })
          .catch((e) => {
            if (e.response.status === 400) {
              this.alreadyFavored = false;

              if (e.response.data['hydra:code'] === 200) {
                this.alreadyFavored = true;
                return;
              }
            }

            throw e;
          });
        setTimeout(() => (this.disabled = false), 3000);
      },
    },
  };
